// extracted by mini-css-extract-plugin
export default {"customer":"R1hAcX","mobile-view":"h_JnnC","mobileView":"h_JnnC"};